<template>
  <v-container grid-list-sm>
    <v-layout>
      <v-flex xs12 md6 offset-sm3>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoReporte
            :titulo="titulo"
            :accion="accion"
            @ejecutarAccion="ejecutarAccion"
          />
          <v-card-text>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex xs12 md8>
                  <v-radio-group
                    v-model="itemActivo.FiltroPuntoVenta"
                    :mandatory="false"
                  >
                    <v-radio label="Todo" value="Todo"></v-radio>
                    <v-radio
                      label="Un Punto de Venta"
                      value="UnPuntoVenta"
                    ></v-radio>
                    <v-radio label="Un Turno" value="UnTurno"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <div v-if="itemActivo.FiltroPuntoVenta == 'Todo'">
                <v-layout row wrap>
                  <v-flex xs12 md4>
                    <Fecha
                      label="Hasta*"
                      :fecha="itemActivo.FechaHasta"
                      :rules="[rules.requerido]"
                      @seleccionarItem="
                        item => (itemActivo.FechaHasta = item.Fecha)
                      "
                    />
                  </v-flex>
                </v-layout>
              </div>
              <div v-else>
                <div v-if="itemActivo.FiltroPuntoVenta == 'UnPuntoVenta'">
                  <v-layout row wrap>
                    <v-flex xs12 md8>
                      <SelectPuntoVenta
                        :model="itemActivo.Id_PuntoVenta"
                        :rules="[rules.requerido]"
                        @seleccionarItem="seleccionarPuntoVenta"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md4>
                      <Fecha
                        label="Hasta*"
                        :fecha="itemActivo.FechaHasta"
                        :rules="[rules.requerido]"
                        @seleccionarItem="
                          item => (itemActivo.FechaHasta = item.Fecha)
                        "
                      />
                    </v-flex>
                  </v-layout>
                </div>
                <div v-else>
                  <v-layout row wrap>
                    <v-flex xs12 md12>
                      <SelectCaja
                        :model="itemActivo.Id_Caja"
                        :rules="[rules.requerido]"
                        @seleccionarItem="seleccionarCaja"
                      />
                    </v-flex>
                  </v-layout>
                </div>
              </div>
            </v-form>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import EncabezadoReporte from "@/components/EncabezadoReporte";
import PieCrud from "@/components/PieCrud";
import Mensaje from "@/components/Mensaje";
import SelectPuntoVenta from "@/components/Sistema/SelectPuntoVenta";
import Fecha from "@/components/Fecha";
import SelectCaja from "@/components/Caja/SelectCaja";
export default {
  name: "VentaListarSaldos",
  components: {
    EncabezadoReporte,
    PieCrud,
    Mensaje,
    SelectPuntoVenta,
    Fecha,
    SelectCaja
  },
  data() {
    return {
      titulo: "Saldos Deudores",
      itemVacio: {
        FiltroPuntoVenta: "Todo",
        NombrePuntoVenta: "",
        Id_PuntoVenta: 0,
        FechaHasta: "",
        Turno: 0
      },
      itemActivo: {},
      rules: {
        requerido: v => !!v || "Requerido"
      },
      loading: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      accion: ""
    };
  },
  created() {
    this.inicializar();
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Imprimir":
        case "ExportarXls":
          if (this.$refs.form.validate()) this.imprimir();
          break;
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          this.$refs.form.resetValidation();
          this.inicializar();
          break;
      }
    },
    inicializar() {
      this.itemActivo = Object.assign({}, this.itemVacio);
    },
    seleccionarPuntoVenta(item) {
      this.itemActivo.Id_PuntoVenta = item.Id_PuntoVenta;
      this.itemActivo.NombrePuntoVenta = item.Nombre;
    },
    seleccionarCaja(item) {
      this.itemActivo.Id_Caja = item.Id_Caja;
      this.itemActivo.Id_PuntoVenta = item.Id_PuntoVenta;
      this.itemActivo.FechaHasta = item.Fecha;
      this.itemActivo.Turno = item.Turno;
    },
    imprimir() {
      this.loading = true;
      HttpHelper.getBlob("Venta/ListarSaldos", {
        accion: this.accion,
        filtroPuntoVenta:
          this.itemActivo.FiltroPuntoVenta == "Todo"
            ? this.itemActivo.FiltroPuntoVenta
            : this.itemActivo.NombrePuntoVenta,
        id_PuntoVenta:
          this.itemActivo.FiltroPuntoVenta == "Todo"
            ? 0
            : this.itemActivo.Id_PuntoVenta,
        fechaHasta: this.itemActivo.FechaHasta,
        id_Caja:
          this.itemActivo.FiltroPuntoVenta == "Todo"
            ? 0
            : this.itemActivo.Id_Caja,
        turno: this.itemActivo.Turno
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          let fileName = response.headers["content-disposition"]
            .split(";")[1]
            .split("=")[1]
            .trim();
          link.setAttribute("download", "Reporte_" + fileName);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    mostrarError(error) {
      var detalle;
      detalle =
        error.response == undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
